var e=(r=>(r.INVALID_FORMAT="invalid-format",r.VALIDATION="validation-error",r))(e||{});class o extends CustomEvent{constructor(t){super("error",{detail:t,bubbles:!0})}}export{o as NgcErrorEvent,e as NgcErrorReason};
